import script from "./titleText.vue?vue&type=script&setup=true&lang=js"
export * from "./titleText.vue?vue&type=script&setup=true&lang=js"

import "./titleText.vue?vue&type=style&index=0&id=23432655&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23432655"]])

export default __exports__